import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { CategoryTable } from '@/components/Pages/Categories/CategoryTable';
import { CreateEditCategoryModal } from '@/components/Pages/Categories/CreateEditCategoryModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/categories')({
  component: CategoriesPage,
  head: () => pageTitle('Categorías'),
});

function CategoriesPage() {
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('CATEGORIES_READ');
  const canWrite = hasClaim('CATEGORIES_WRITE');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditCategoryModal />
        </Box>
      )}
      <CategoryTable />
    </Box>
  );
}
